//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { FAKE_BAZAARVOICE_NETWORK_CONTAINER_ID } from '@galleries/constants/galleriesConstants';

export const getIsBazaarvoiceNetworkGallerySelected = createSelector(
  (state: ICuralateStore) => state.galleries.picker.selectedGalleryId,
  (selectedGalleryId) =>
    selectedGalleryId === FAKE_BAZAARVOICE_NETWORK_CONTAINER_ID,
);
